// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"48":"bc4ce4d4","455":"bc4ce4d4","551":"8a9d9a46","998":"bc4ce4d4"}[chunkId] + ".chunk.css";
};